import { defineMessages } from 'react-intl';

export default defineMessages({
  salesSummary: {
    defaultMessage: 'Sales ({currency})',
    id: 'x8mTZq',
    description: 'sales in seller currency y-axis label',
  },
  salesVsLastPeriod: {
    defaultMessage: 'Sales vs Last Period',
    id: '8SUIfB',
    description: 'Sales vs Last Period label',
  },
  salesVsTimeLastYear: {
    defaultMessage: 'Sales vs Time Last Year',
    id: 'pwV699',
    description: 'Sales vs Time Last Year label',
  },
  averageOrderValue: {
    defaultMessage: 'Average Order Value ({currency})',
    id: 'X8bLnN',
    description: 'Average Order Value label',
  },
  orders: {
    defaultMessage: 'Orders',
    id: '+DChmA',
    description: 'Orders label',
  },
  newCustomers: {
    defaultMessage: 'New Customers',
    id: '7vgBS9',
    description: 'new customers label',
  },
  returningCustomers: {
    defaultMessage: 'Returning Customers',
    id: 'DpbU46',
    description: 'Returning customers label',
  },
  yAxisLabel: {
    defaultMessage: '# Items Sold',
    id: '2gygmE',
    description: 'label for y axis describing the number of items that have been sold',
  },
  itemsSold: {
    defaultMessage: 'Items Sold',
    id: 'j5kvYY',
    description: 'items sold label used in tooltip and legend',
  },
  sales: {
    defaultMessage: 'Sales ({currency})',
    id: 'gxiIgJ',
    description: 'sales with currency label used in tooltip and legend',
  },
  revenueWithCurrency: {
    defaultMessage: 'Revenue ({currency})',
    id: 'TuP6mu',
    description: 'Revenue in selected currency label for right hand side of the graph',
  },
  salesandCustomersReportTitle: {
    defaultMessage: 'Sales Revenue',
    id: '2C5Jbe',
    description: 'Sales Revenue Chart Title',
  },
});
